
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: "source-offer",
components: {Popup},
props: ['sourceDto', 'defaultPar', 'rotation'],
data() {
return {
popupShow: false,
viewStage: {},
ratingVisible:false,
ratingMenus:[]
}
},
methods: {
viewRealInfo(stage) {
this.viewStage = stage;
this.popupShow = true;
},
viewScorePlan(round){
this.ratingVisible = true;
let list = [];
round.sourceRatingList.forEach((item) => {
let obj = {
label:item.sourceRatingNo,
value:item.id
};
list.push(obj);
});
this.ratingMenus = list;
},
clickRatingMenu(e){
this.$router.push(`/source-score/view/${e}`);
}
}
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-offer.vue